<template>
  <div class="chart-main" ref="chartInstance"> </div>
</template>
<script>

// import {MixinChartsOptions} from './utils/chartsOptionsMixin'
// const mixinsOptions = new MixinChartsOptions()

export default {
  props: {
    options: Object
  },
  data() {
    return {
      chartInstance: null,
      setOptionObj: {}
    }
  },
  watch: {
    options(val) {
      this.setOptionObj = val
      this.initChart()
    }
  },
  mounted() {
    this.initChart()

    window.addEventListener('resize', () => { this.resize() })
  },
  methods: {
    initChart() {
      if (this.chartInstance) {
        this.chartInstance.dispose()
      }
      this.chartInstance = this.$echarts.init(this.$refs.chartInstance, null, {renderer: 'svg'})
      // 图表点击事件
      this.chartInstance.on('click', params => {
        this.$emit('echartClick', params)
      })
      // const options = {}
      // const mixedOptions = mixinsOptions.mixinOptions(options, this.setOptionObj || {}) // 融合自定义的配置和默认的配置

      this.chartInstance.setOption(this.setOptionObj)
      // 下面的是自适应屏幕大小去缩放
      this.$nextTick(() => {
        setTimeout(() => this.resize(), 500)
      })
    },
    resize() {
      this.chartInstance.resize()
    }
  },
  beforeDestroy() {
    // eslint-disable-next-line no-unused-expressions
    this.chartInstance && this.chartInstance.dispose()
  }
}
</script>
